<prime-dialog [visible]="visible()" [headerRef]="true" [breakpoints]="breakpoints()" [style]="styles()" (onCloseButton)="onClose()">
  <header class="flex-grow-1" dialog-title>
    <h1 class="font-bold text-center p-3">
      Términos y Condiciones
    </h1>
  </header>
  <div dialog-body class="px-3">
    <app-terms-and-conditions />
  </div>
</prime-dialog>
